<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title29"></a>
<div class="p-c-br"><span>To Lyn Cluer-Coleman and to <br/>The Stroud House Gallery. <br/>With much love.</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781466821705_ded01.vue?a755f7b8